@if (isVisible) {
  <div class="date-range-field" [ngClass]="config.class" [formGroup]="group">
    <div class="date-range-label">
      {{ config.label }}@if (config.required) { <span class="required-star">*</span> }
    </div>
    <div class="date-range-inputs">
      <mat-form-field appearance="outline" class="date-range-from">
        <mat-label>{{ fromPlaceholder }}</mat-label>
        <input matInput
               [matDatepicker]="fromPicker"
               [placeholder]="fromPlaceholder"
               (focus)="fromPicker.open()"
               (click)="fromPicker.open()"
               readonly
               [formControlName]="config.name"
               [min]="minDate"
               [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="fromPicker" [disabled]="config.disbaledProperty"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker [disabled]="config.disbaledProperty"></mat-datepicker>
        @if (config.showErrorText && group.controls[config.name]?.invalid && group.controls[config.name]?.touched) {
          <mat-error>{{ 'common.fieldRequired' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="date-range-to">
        <mat-label>{{ toPlaceholder }}</mat-label>
        <input matInput
               [matDatepicker]="toPicker"
               [placeholder]="toPlaceholder"
               (focus)="toPicker.open()"
               (click)="toPicker.open()"
               readonly
               [formControlName]="config.toName"
               [min]="minDate"
               [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="toPicker" [disabled]="config.disbaledProperty"></mat-datepicker-toggle>
        <mat-datepicker #toPicker [disabled]="config.disbaledProperty"></mat-datepicker>
        @if (config.showErrorText && config.toName && group.controls[config.toName]?.invalid && group.controls[config.toName]?.touched) {
          <mat-error>{{ 'common.fieldRequired' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
}
